export default function keyMirror(obj) {
    const keys = Object.keys(obj);
    var result = {};

    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        result[key] = key;
    }
    
    return result;
}
